import { Lock, ShieldCheck, GlobeLock } from "lucide-react";
import Card from '@/components/common/ui/Card';

const plans = [
  {
    title: "Increase traffic with SSL",
    description:
      "HTTPS is now a requirement for most search engines, increasing ranking and favouring websites with SSL encryption. SSL has never been so important to fully protect your website and improve your SEO.",
    icon: GlobeLock, // SEO + HTTPS
  },
  {
    title: "Strong encryption",
    description:
      "Our SSL certificates use the most secure encryption methods (SHA-2 & ECC), converting your data into impenetrable code and protecting sensitive information from cyber attackers.",
    icon: Lock, // Encryption & security
  },
  {
    title: "Fully verified SSL",
    description:
      "All Premium EV SSL certificates include a click-to-verify site seal and business verification, giving customers confidence and building instant trust.",
    icon: ShieldCheck, // Verification & trust
  },
];

export default function WhySSL() {
    return (
        <section className="container pb-24 pt-12">
            <div className="text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Why SSL?
                </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}